import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { DashboardPage } from "./pages/Dashboard/DashboardPage";
import { ROUTE_PREFIX as CATEGORIES_ROUTE_PREFIX } from "./modules/Categories/utils/ModuleHelpers";
import { ROUTE_PREFIX as SKILLS_ROUTE_PREFIX } from "./modules/Skills/utils/ModuleHelpers";
import { ROUTE_PREFIX as LOCATIONS_ROUTE_PREFIX } from "./modules/Locations/utils/ModuleHelpers";
import { ROUTE_PREFIX as COUNTRIES_ROUTE_PREFIX } from "./modules/Countries/utils/ModuleHelpers";
import { ROUTE_PREFIX as SUBCATEGORIES_ROUTE_PREFIX } from "./modules/Subcategories/utils/ModuleHelpers";
import VerifyEmail from "./pages/VerifyEmail";
import { ROUTE_PREFIX as EMY_PROJECT_ROUTE_PREFIX } from "./modules/EmyProjects/helpers/RoutingHelpers";
import { ROUTE_PREFIX as EMY_SERVICE_ROUTE_PREFIX } from "./modules/EmyServices/helpers/RoutingHelpers";
import { ROUTE_PREFIX as EMY_PRODUCT_ROUTE_PREFIX } from "./modules/EmyProducts/helpers/RoutingHelpers";
import { ROUTE_PREFIX as USER_ROUTE_PREFIX } from "./modules/Users/helpers/RoutingHelpers";
import { ROUTE_PREFIX as TEAM_ROUTE_PREFIX } from "./modules/Teams/helpers/RoutingHelpers";
import { ROUTE_PREFIX as GROUP_ROUTE_PREFIX } from "./modules/Groups/helpers/RoutingHelpers";
import { ROUTE_PREFIX as CONTACT_ROUTE_PREFIX } from "./modules/Contacts/helpers/RoutingHelpers";
import { ROUTE_PREFIX as CALENDAR_ROUTE_PREFIX } from "./modules/Calendar/helpers/RoutingHelpers";
import { ROUTE_PREFIX as CHAT_ROUTE_PREFIX } from "./modules/Chat/helpers/RoutingHelpers";
import { ROUTE_PREFIX as PROPOSAL_ROUTE_PREFIX } from "./modules/Proposals/helpers/RoutingHelpers";
import { ROUTE_PREFIX as EMY_COIN_ROUTE_PREFIX } from "./modules/EmyCoins/helpers/RoutingHelpers";
import { ROUTE_PREFIX as EMY_WALLET } from "./modules/EmyWallet/helpers/RoutingHelpers";
import { Edit as UpdateProfile } from "./modules/Users/pages/edit/Edit";
import AddFunds from "./modules/EmyWallet/AddFunds";

/**/
const EmyProjects = lazy(() => import("./modules/EmyProjects"));
const EmyServices = lazy(() => import("./modules/EmyServices"));
const EmyProducts = lazy(() => import("./modules/EmyProducts"));
const Categories = lazy(() => import("./modules/Categories"));
const Skills = lazy(() => import("./modules/Skills"));
const Locations = lazy(() => import("./modules/Locations"));
const Countries = lazy(() => import("./modules/Countries"));
const Subcategories = lazy(() => import("./modules/Subcategories"));
const Users = lazy(() => import("./modules/Users"));
const Teams = lazy(() => import("./modules/Teams"));
const Groups = lazy(() => import("./modules/Groups"));
const Contacts = lazy(() => import("./modules/Contacts"));
const Calendar = lazy(() => import("./modules/Calendar"));
const Chat = lazy(() => import("./modules/Chat"));
const Proposal = lazy(() => import("./modules/Proposals"));
const EmyCoin = lazy(() => import("./modules/EmyCoins"));
const EmyWallet = lazy(() => import("./modules/EmyWallet"));

export default function BasePage() {
  // const locale = useLang();
  // const {formatMessage} = useIntl();
  // useEffect(
  //   ()=>{
  //       setLocale({
  //           mixed: {
  //               required: formatMessage({ id: "AUTH.VALIDATION.REQUIRED_FIELD" }),
  //           },
  //       });
  //   },[locale])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/verified-email/:token" component={VerifyEmail} />
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/update-profile" component={UpdateProfile} />
        {/**/}
        <Route path={EMY_PROJECT_ROUTE_PREFIX} component={EmyProjects} />
        <Route path={EMY_SERVICE_ROUTE_PREFIX} component={EmyServices} />
        <Route path={EMY_PRODUCT_ROUTE_PREFIX} component={EmyProducts} />
        <Route path={CATEGORIES_ROUTE_PREFIX} component={Categories} />
        <Route path={SKILLS_ROUTE_PREFIX} component={Skills} />
        <Route path={LOCATIONS_ROUTE_PREFIX} component={Locations} />
        <Route path={COUNTRIES_ROUTE_PREFIX} component={Countries} />
        {/* <Route path={"/wallet"} component={AddFunds} /> */}
        <ContentRoute
          path={SUBCATEGORIES_ROUTE_PREFIX}
          component={Subcategories}
        />
        <ContentRoute path={USER_ROUTE_PREFIX} component={Users} />
        <ContentRoute path={TEAM_ROUTE_PREFIX} component={Teams} />
        <ContentRoute path={GROUP_ROUTE_PREFIX} component={Groups} />
        <ContentRoute path={CONTACT_ROUTE_PREFIX} component={Contacts} />
        <ContentRoute path={CALENDAR_ROUTE_PREFIX} component={Calendar} />
        <ContentRoute path={CHAT_ROUTE_PREFIX} component={Chat} />
        <ContentRoute path={PROPOSAL_ROUTE_PREFIX} component={Proposal} />
        <ContentRoute path={EMY_COIN_ROUTE_PREFIX} component={EmyCoin} />
        {/* wallet */}
        <ContentRoute path={EMY_WALLET} component={EmyWallet} />
        {/*<Redirect to="/error/error-v1"/>*/}
      </Switch>
    </Suspense>
  );
}
